"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _eventBus = require("@/helpers/event-bus.js");

var _vuex = require("vuex");

var _Workflow = _interopRequireDefault(require("@/components/Workflow"));

var _LotDetail = _interopRequireDefault(require("./components/LotDetail"));

var _LotDetailBudgetComp = _interopRequireDefault(require("./components/LotDetailBudgetComp"));

var _LotDetailTotaux = _interopRequireDefault(require("./components/LotDetailTotaux"));

var _AffaireTotaux = _interopRequireDefault(require("./components/AffaireTotaux"));

var _Synthese = _interopRequireDefault(require("./components/Synthese"));

var apiLotDetail = _interopRequireWildcard(require("@/api/lotdetail"));

var apiAffaire = _interopRequireWildcard(require("@/api/affaire"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

var _moment = _interopRequireDefault(require("moment"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'GestMensuelle',
  components: {
    Workflow: _Workflow.default,
    LotDetail: _LotDetail.default,
    LotDetailBudgetComp: _LotDetailBudgetComp.default,
    LotDetailTotaux: _LotDetailTotaux.default,
    AffaireTotaux: _AffaireTotaux.default,
    Synthese: _Synthese.default
  },
  data: function data() {
    return {
      refresh: 0,
      CONST: CONST,
      refreshValidBtnGestMens: 0,
      userCanDoAction: false
    };
  },
  beforeMount: function () {
    var _beforeMount = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this = this;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getWorkflow('gestion_mensuelle').then(function () {
                _this.userCanDoAction = _this.isUserCanDoAction(CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value, 'gestion_mensuelle');
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeMount() {
      return _beforeMount.apply(this, arguments);
    }

    return beforeMount;
  }(),
  mounted: function mounted() {
    _eventBus.EventBus.$emit('REFRESH_CALCULS');
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user']), {
    affaire: function affaire() {
      return this.$store.getters.affaire;
    }
  }),
  methods: {
    canEdit: function canEdit() {
      // edition possible uniquement si on est sur la période de gestion courante.
      return this.affaire.YYYYMM === this.affaire.currentGestMensYYYYMM;
    },
    periodeGestion: function periodeGestion() {
      _moment.default.locale('fr');

      var periode = (0, _moment.default)(this.$store.getters.affaire.YYYYMMmoins1, 'YYYYMM').format('MMMM YYYY');
      var isValidDate = (0, _moment.default)(this.$store.getters.affaire.YYYYMMmoins1, 'YYYYMM', true).isValid();
      return this.$store.getters.affaire.currentGestMensYYYYMM && isValidDate ? 'Gestion de ' + periode : '';
    },
    // appel à partir de l'icone pour passer le lot en mode edition
    handleModeEdit: function handleModeEdit(lot) {
      // envoi le signal pour passer le lot en mode edition, traité dans le composant LotDetail
      _eventBus.EventBus.$emit('EDIT_LOT', lot.id);
    },
    // =============================================
    handleBeforeToValidate: function handleBeforeToValidate(workflow) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var totaux = _this2.affaire.calculs.affaire;
        var mtBgtAff = Number(totaux.mtTotalGeneralBudgetGlobalAffaire).toFixed(2);
        var mtBgtDeb = Number(totaux.mtTotalGeneralBudgetDebloque).toFixed(2);
        var pcCumulM = mtBgtAff !== 1 ? mtBgtDeb / mtBgtAff : 0;

        if (pcCumulM > 1) {
          _this2.$alert('Pourcentage Cumul M > 100%', 'Soumettre à validation impossible', {
            confirmButtonText: 'OK',
            type: 'error'
          });

          var error = new Error("Validation impossible: Pourcentage Cumul M > 100% (".concat(pcCumulM, ")"));
          error.stack = '';
          reject(error);
        } else {
          resolve();
        }
      });
    },
    handleAfterValidatedGestMens: function handleAfterValidatedGestMens(workflow) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        // on valide les lignes cochées si des lignes ont leur champ validation = 1 pour les passer 2
        apiLotDetail.validateByAffaireId(_this3.affaire.affaire.id); // mise à jour de la période de gestion mensuelle de l'affaire

        apiAffaire.update(_this3.affaire.affaire.id, {
          periode_gestmens: workflow.periode_gestmens
        }).then(function (result) {
          if (result.affectedRows > 0) {
            var periode = (0, _moment.default)(workflow.periode_gestmens, 'YYYYMM').format('MM/YYYY'); // mise à jour de l'historique pour signaler la date d'ouverture de la nouvelle période de gestion mensuelle

            var histo = {
              id: _this3.affaire.affaire.id,
              etape: CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value,
              status: CONST.AFFAIRE.STATUS.VALIDSYNTHESE.value,
              message: 'Ouverture de la période de gestion du ' + periode,
              data: workflow.periode_gestmens
            };

            _this3.$store.dispatch('affaire/setHistorique', histo);

            _this3.$store.dispatch('affaire/updatePeriodeGestMens', _this3.affaire.affaire.id);

            _this3.$message({
              message: 'Ouverture de la gestion mensuelle pour la période du ' + periode,
              type: 'success'
            });

            resolve();
          } else {
            reject(new Error());
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }
};
exports.default = _default;